import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const WorkOrderService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getByCode(code, select = null) {
    const requestScreenData = {
      url: "api/WorkOrder",
      top: "1",
      filter: `Code eq ${code}`,
      // select:
      //   "CustomerStopCredit,Code,QuoteCode,BomCode,ShipDate,ScheduledDate,ItemQty,DivisionCode,BranchCode,Comment,ProductCode,CreatedBy,DateCreated,DateCompleted,ChangedBy,DateChanged,FriendlyStatus,MTSQuantity,SalesOrderStockUMQuantity,ActualQty,Status,TotalSortHour,TotalTegraHour,TotalLabourHour,TotalDownTimeHour,DownTimeComment, ReleaseDepartmentCode, ReleaseDepartmentName, PlannedCompletionDate, SchedulingMethod",
    };

    if (select) {
      requestScreenData.select = select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async save(payload) {
    const url = "api/Save_WorkOrder";

    return await ApiService.post(url, payload);
  },

  async completeWorkOrder(payload) {
    const url = "api/WorkOrder/Complete";

    return await ApiService.post(url, payload);
  },

  async reopenWorkOrder(payload) {
    const url = "api/WorkOrder/ReOpen";

    return await ApiService.post(url, payload);
  },

  async cancelWorkOrder(payload) {
    const url = "api/WorkOrder/Cancel";

    return await ApiService.post(url, payload);
  },
  async getProductDataForAddInDataSource(productCode, branchCode) {
    const requestScreenData = {
      url: "api/WorkOrderAddInItemCompanyBranch",
      filter: `ItemCode eq '${productCode}' and BranchCode eq '${branchCode}' and IsDefault eq 'Y'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async workOrderReschedule(payload) {
    const url = "api/Save_WorkOrderReschedule";

    return await ApiService.post(url, payload);
  },
  async getWorkOrderAddIns(workOrderCode) {
    const requestScreenData = {
      url: "api/WorkOrderAddInList",
      filter: `WorkOrderCode eq ${workOrderCode}`,
      orderby: "DateCreated asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getWOSOLines(WOCode) {
    const requestScreenData = {
      url: "api/WorkOrderToSalesOrderLineList",
      filter: `WorkOrderCode eq ${WOCode}`,
      orderby: "PackDate asc,Position asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderMaterialList(WOCode, params) {
    try {
      const requestScreenData = {
        url: "api/WorkOrderMaterial",
        filter: `WorkOrderCode eq ${WOCode} and IssueType eq 'Material'`,
      };

      if (params) {
        if (params.filter) {
          requestScreenData.filter += ` and ${params.filter}`;
        }
      }

      return await ApiService.oDataGet(requestScreenData);
    } catch (e) {
      return null;
    }
  },

  async getBomUnitOfMeasure(code) {
    const requestScreenData = {
      url: "api/BomUnitOfMeasure",
      filter: `BomCode eq '${code}' and IsDefault eq 'Y'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getBOMByCode(code) {
    const requestScreenData = {
      url: "api/Bom",
      top: "1",
      filter: `Code eq '${code}'`,
      select:
        "Code,Comment,Description1,Description2,ProductCode,BatchSize,BranchCode,DivisionCode,BomTypeCode,Status",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async reOrderWorkOrder(payload) {
    const url = "api/WorkOrder/ReorderProcessWorkOrderSequence";

    return await ApiService.post(url, payload);
  },

  async getWorkOrderSalesOrderDetailLine(SalesOrderCode, SalesOrderLine) {
    const requestScreenData = {
      url: "api/PickingSlipDetail",
      top: 1,
      filter: `SalesOrderCode eq ${SalesOrderCode} and LineNo eq ${SalesOrderLine}`,
      select: "SalesOrderCode,LineNo,SalesUMBackorderQty,StockUMBackorderQty",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderSalesOrderLines(filter) {
    const requestScreenData = {
      url: "api/WorkOrderSalesOrderDetailLineList",
      filter: filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getBOMByProductCode(code) {
    const requestScreenData = {
      url: "api/Bom",
      top: "1",
      filter: `ProductCode eq '${code}'`,
      select: [
        "Code",
        "Comment",
        "Description1",
        "Description2",
        "ProductCode",
        "BatchSize",
        "BranchCode",
        "DivisionCode",
        "BomTypeCode",
        "Status",
      ],
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderStatus() {
    const requestScreenData = {
      url: "api/WorkOrderStatus",
      filter: `Inactive eq 'N'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderStatusTransition(from, workOrderCode = null) {
    let requestScreenData = {
      url: "api/WorkOrderStatusTransitionList",
    };

    if (workOrderCode) {
      requestScreenData.url += `?workOrderCode=${workOrderCode}&$filter=Inactive eq 'N' and (FromStatusCode eq '${from}')&$orderby=Sequence`;
    } else {
      requestScreenData.filter = `Inactive eq 'N' and (FromStatusCode eq '${from}')`;
      requestScreenData.orderby = "Sequence";
    }

    return await ApiService.oDataGet(requestScreenData);
  },


  async getWorkOrderHeaderSummary(code, WorkOrderInstance) {

    let url = "api/WorkOrder/HeaderSummaryAlmondco?WorkOrderCode=" + code;
    if (WorkOrderInstance === 'Core') {
      url = "api/WorkOrder/HeaderSummary?WorkOrderCode=" + code;
    }

    const requestScreenData = {
      url: url,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderCostSummary(code) {
    const requestScreenData = {
      url: "api/WorkOrderHeaderCostSummary",
      filter: `WorkOrderCode eq ${parseInt(code)}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderProcessList(WorkOrderCode) {
    const requestScreenData = {
      url: "api/WorkOrderProcess",
      filter: `WorkOrderCode eq ${WorkOrderCode}`,
      orderby: "ProcessSequence asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderLabourList(WorkOrderCode, params) {
    const requestScreenData = {
      url: "api/WorkOrderLabour",
      filter: `WorkOrderCode eq ${WorkOrderCode}`,
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderShiftAllocationList(WorkOrderCode) {
    const requestScreenData = {
      url: "api/ShiftAllocation",
      filter: `WorkOrderCode eq ${WorkOrderCode}`,
      orderby: "ProcessCode asc",
      expand: 'Process($select=Description)',
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async updateMaterialSubstitute(payload) {
    return await ApiService.post("api/WorkOrder/MaterialSubstitution", payload);
  }
}
export { WorkOrderService };
